<template>
<div class="bg-main">
	<v-container>
		<v-row :justify="'start'" :align="'start'">
			<v-col v-for="b in beneficios" cols="6" :key="b.title" sm="6" md="6">
				<v-card v-if="b.statusFormulario ===  'RESPONDEU_FORMULARIO' ">
          <v-card-title>{{b.titulo}}</v-card-title>
					<v-card-subtitle class="text--accent-1 text--primary">O formulário já foi preenchido</v-card-subtitle>
				</v-card>
				<v-card @click="go(b.url)" v-else>
					<v-card-title>{{b.titulo}}</v-card-title>
					<v-card-subtitle>{{b.subtitulo}}</v-card-subtitle>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</div>
</template>

<script>
import axios from 'axios';

export default {
	name: "Beneficio",
	async mounted() {
		let response = await axios.get('/beneficio');
		this.beneficios = response.data;
	},
	data: () => ({
		beneficios: [ ]
	}),
	methods: {
		go (url) {
			this.$router.push({
				name: 'BeneficioDetail',
				params: {nome: url}
			});
		}
	}
}
</script>

<style scoped>

</style>
